import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const ExistingDeliverableWrapper = styled.div`
  margin-top: 16px;

  ${responsive.MOBILE`
      margin-top: 0px;
  `}

  .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type,
  .checkbox-cell {
    padding: 0 16px !important;
  }

  .cell-name {
    width: 290px;
  }

  .existing-header {
    padding-left: 16px;

    .existing-deliverable {
      ${responsive.MOBILE`
       padding: 8px;
       `}
    }

    ${responsive.MOBILE`
       width: 100%;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       padding: 1px;
    `}
  }
`;
